module.exports.run = function(output, STATUSES, isMethodStatus = false){

  const filler = isMethodStatus
    ? 'Method'
    : '';

  output[`get${filler}StatusRange`] = function(name1, name2){
    const start = this[`get${filler}StatusCodeFromName`](name1);
    const end = this[`get${filler}StatusCodeFromName`](name2);
    return { start, end };
  };

  output[`get${filler}StatusCodeFromName`] = function(name){
    const doc = STATUSES.find(
      d => d.name === name
    );
    return doc && doc.code;
  };
  
  output[`get${filler}StatusNameFromCode`] = function(code){
    const doc = STATUSES.find(
      d => d.code === code
    );
    return doc && doc.name;
  };
  
  output[`get${filler}StatusDocument`] = function({ code, name }){
    return STATUSES.find(
      d => d.name === name || d.code === code
    );
  };

  output[`get${filler}StatusName`] = function(){
    const doc = STATUSES.find(
      d => d.code === this.status
    );
    return doc && doc.name;
  };

  output[`get${filler}StatusTitle`] = function(){
    const doc = STATUSES.find(
      d => d.code === this.status
    );
    return doc && doc.title;
  };

  output[`isCurrent${filler}Status`] = function(name){
    const doc = STATUSES.find(
      d => d.name === name
    );
    return doc && doc.code === this.status;
  };

  output[`isGreaterThan${filler}Status`] = function(name){
    const doc = STATUSES.find(
      d => d.name === name
    );
    return doc && this.status > doc.code;
  };

  output[`isGreaterThanOrEqual${filler}Status`] = function(name){
    const doc = STATUSES.find(
      d => d.name === name
    );
    return doc && this.status >= doc.code;
  };

  output[`isLessThan${filler}Status`] = function(name){
    const doc = STATUSES.find(
      d => d.name === name
    );
    return doc && this.status < doc.code;
  };

  output[`isLessThanOrEqual${filler}Status`] = function(name){
    const doc = STATUSES.find(
      d => d.name === name
    );
    return doc && this.status <= doc.code;
  };

  output[`isBetween${filler}Status`] = function(name1, name2){
    const doc1 = STATUSES.find(
      d => d.name === name1
    );
    const doc2 = STATUSES.find(
      d => d.name === name2
    );
    return doc1 && doc2 && doc1.code <= this.status && doc2.code >= this.status;
  };

  output[`set${filler}Status`] = function(statusName){
    const code = this[`get${filler}StatusCodeFromName`](statusName);
    const modifier = { $set: {}};
    if(isMethodStatus){
      modifier.$set.method_status = code;
    }
    else {
      modifier.$set.status = code;
    }
    return this.update(modifier);
  };

  if(isMethodStatus){
    
    output.clearMethodStatus = function(){

      return this.update(
        { $unset: { method_status: '' }}
      );
    };
  }
};